import Badge from 'routes/Badge'

export default Badge
